import '@fontsource/baloo-2/600.css';
import '@fontsource/baloo-2/800.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import store from './store';

// Android hands over its system-bar insets (see MainActivity.java) as CSS variables.
const applyInsets = (csv: string) => {
    const [top, right, bottom, left] = csv.split(',').map(Number);
    const style = document.documentElement.style;
    style.setProperty('--inset-top', `${top || 0}px`);
    style.setProperty('--inset-right', `${right || 0}px`);
    style.setProperty('--inset-bottom', `${bottom || 0}px`);
    style.setProperty('--inset-left', `${left || 0}px`);
};
(window as unknown as { __applyInsets: typeof applyInsets }).__applyInsets =
    applyInsets;
const nativeInsets = (
    window as unknown as { AndroidInsets?: { get(): string } }
).AndroidInsets;
if (nativeInsets) applyInsets(nativeInsets.get());

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);

// Offline-capable PWA on the web. In the Capacitor app the assets are already local.
serviceWorkerRegistration.register();

reportWebVitals();
